/**
 * Normalizes a value for dirty-state comparison.
 * Treats `null`, `undefined`, and empty string `''` as equivalent
 * so that a field initialised as `undefined` from the server is not
 * considered dirty when the controlled input defaults it to `''`.
 */
export function normalizeValue(val: unknown): unknown {
    if (val === null || val === undefined || val === '') return '';
    return val;
}

/**
 * Returns `true` if `current` differs from `initial`,
 * treating `null` / `undefined` / `''` as the same value.
 */
export function isFieldDirty(current: unknown, initial: unknown): boolean {
    return normalizeValue(current) !== normalizeValue(initial);
}

export interface DirtyField {
    current: unknown;
    initial: unknown;
}

/**
 * Returns `true` if **any** of the supplied field pairs are considered dirty.
 *
 * @example
 * const isDirty = useIsDirty([
 *   { current: customerId,   initial: initialCustomerId },
 *   { current: creditAmount, initial: initialCreditAmount },
 * ]);
 */
export function useIsDirty(fields: DirtyField[]): boolean {
    return fields.some(({ current, initial }) =>
        isFieldDirty(current, initial)
    );
}
